export default "__VITE_ASSET__CKCLb9QE__"